import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const _consoleLog = console.log.bind(console);
const _consoleWarn = console.warn.bind(console);
const _consoleError = console.error.bind(console);

if (!environment.enableLogging) {
  console.log = () => {};
  console.warn = () => {};
}

(window as any).enableLogging = () => {
  console.log = _consoleLog;
  console.warn = _consoleWarn;
  console.error = _consoleError;
  console.log('Logging enabled.');
};

(window as any).disableLogging = () => {
  console.log = () => {};
  console.warn = () => {};
  console.log('Logging disabled.');
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
